import React, { useEffect, useState } from 'react';
import { getEffective, getOverride, setOverride, clearOverride,
         onAutoLoadChange, onOverrideChange } from '@paxsudos/upload-by-url/auto_load_prefs';

export default function AutoLoadToggle() {
  const [on, setOn] = useState(getEffective());

  // pysy synkassa globaalin ja override-muutosten kanssa
  useEffect(() => {
    const off1 = onAutoLoadChange(() => setOn(getEffective()));
    const off2 = onOverrideChange(() => setOn(getEffective()));

    // nollaa override kun tootti lähetetään
    const form = document.querySelector('form.compose-form');
    const reset = () => clearOverride();
    if (form) form.addEventListener('submit', reset);

    return () => {
      off1(); off2();
      if (form) form.removeEventListener('submit', reset);
    };
  }, []);

  const toggle = () => {
    const curOverride = getOverride();     // null = käytössä globaali
    const next = !getEffective();
    // aseta nimenomaan override, globaalia ei muuteta
    setOverride(next);
    setOn(next);
  };

  const title = on ? 'Median upotus päällä' : 'Median upotus pois päältä';

  return (
    <button
      type="button"
      className="compose-form__button"
      aria-pressed={on}
      title={title}
      onClick={toggle}
      style={{ opacity: on ? 1 : 0.5 }}
    >
      {/* yksinkertainen ikonivaihto */}
      {on ? '🖼️' : '🚫' }
    </button>
  );
}
